import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { OrderHistoryDateRangeValidatorState } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OrderHistoryDateRangeValidatorReducer";

type HandlerType = CustomApiHandler<OrderHistoryDateRangeValidatorState>;

export const HandleDateValidationChange: HandlerType = props => {
    props.dispatch({
        type: "Custom/OrderHistory/DateValidator/SetDateError",
        data: props.parameter,
    });
};

export const chain = [HandleDateValidationChange];

const setDateValidation = createHandlerChainRunner(chain, "SetDateValidation");
export default setDateValidation;
